import { useState } from "react";
import { Switch } from "@headlessui/react";
import { Controller } from "react-hook-form";
import { cn } from "@utils/Cn";

export default function SwitchInput({
  name,
  control,
  className,
  children,
  disabled,
  onChange: onValueChange,
}) {
  return (
    <div className={cn("mt-3 flex", className)}>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange, onBlur } }) => (
          <Switch
            checked={value}
            onChange={(val) => {
              onChange(val);
              if (onValueChange) onValueChange(val);
            }}
            onBlur={onBlur}
            disabled={disabled}
            className={cn(
              "group relative mt-0.5 inline-flex h-5 w-10 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none",
              disabled
                ? "bg-zinc-200/60 data-[checked]:bg-primary-300/70"
                : "cursor-pointer bg-zinc-200 data-[checked]:bg-primary",
            )}
          >
            <span className="sr-only">Use setting</span>
            <span
              aria-hidden="true"
              className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
            />
          </Switch>
        )}
      />
      <div className="ms-2">{children}</div>
    </div>
  );
}
